import { EVENTS } from "../../constants";

class VisibiltyObserver {
  /**
   * adds a specific class to elements when they become visible for the first time
   * e.g. can be used for scroll animations
   *
   * @param {HTMLElement} element - root element
   * @param {string[]} selectors - element selectors
   */
  constructor(element, selectors) {
    this.element = element;
    this.selectors = selectors;
    this._init();
  }

  /**
   * inits intersection observer
   */
  _init() {
    const options = {
      threshold: 1.0,
    };

    const observer = new IntersectionObserver(
      VisibiltyObserver._onIntersecting,
      options
    );

    this.selectors.forEach((selector) => {
      const elements = [...this.element.querySelectorAll(selector)];
      elements.forEach((element) => observer.observe(element));
    });
  }

  /**
   * handles the intersection of the loading element
   *
   * @param { IntersectionObserverEntry[] } entries
   */
  static _onIntersecting(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.dispatchEvent(new CustomEvent(EVENTS.VISIBLE));
      }
    });
  }
}

export default VisibiltyObserver;
